import { createContext } from 'react';

export const TextColorContext = createContext();